/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleCrossSystemDailyRowData } from './GoogleCrossSystemDailyRowData';
import {
    GoogleCrossSystemDailyRowDataFromJSON,
    GoogleCrossSystemDailyRowDataFromJSONTyped,
    GoogleCrossSystemDailyRowDataToJSON,
    GoogleCrossSystemDailyRowDataToJSONTyped,
} from './GoogleCrossSystemDailyRowData';

/**
 * 
 * @export
 * @interface GoogleCrossSystemReportData
 */
export interface GoogleCrossSystemReportData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleCrossSystemReportData
     */
    since?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleCrossSystemReportData
     */
    until?: Date;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemReportData
     */
    projectCurrency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleCrossSystemReportData
     */
    paidAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleCrossSystemReportData
     */
    organicAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleCrossSystemReportData
     */
    googleAnalyticsAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleCrossSystemReportData
     */
    organicSourceSelectionRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleCrossSystemReportData
     */
    googleAnalyticsSourceSelectionRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleCrossSystemReportData
     */
    erpAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleCrossSystemReportData
     */
    datixoEventsAvailable?: boolean;
    /**
     * 
     * @type {Array<GoogleCrossSystemDailyRowData>}
     * @memberof GoogleCrossSystemReportData
     */
    rows?: Array<GoogleCrossSystemDailyRowData>;
}

/**
 * Check if a given object implements the GoogleCrossSystemReportData interface.
 */
export function instanceOfGoogleCrossSystemReportData(value: object): value is GoogleCrossSystemReportData {
    return true;
}

export function GoogleCrossSystemReportDataFromJSON(json: any): GoogleCrossSystemReportData {
    return GoogleCrossSystemReportDataFromJSONTyped(json, false);
}

export function GoogleCrossSystemReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleCrossSystemReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : (new Date(json['since'])),
        'until': json['until'] == null ? undefined : (new Date(json['until'])),
        'projectCurrency': json['projectCurrency'] == null ? undefined : json['projectCurrency'],
        'paidAvailable': json['paidAvailable'] == null ? undefined : json['paidAvailable'],
        'organicAvailable': json['organicAvailable'] == null ? undefined : json['organicAvailable'],
        'googleAnalyticsAvailable': json['googleAnalyticsAvailable'] == null ? undefined : json['googleAnalyticsAvailable'],
        'organicSourceSelectionRequired': json['organicSourceSelectionRequired'] == null ? undefined : json['organicSourceSelectionRequired'],
        'googleAnalyticsSourceSelectionRequired': json['googleAnalyticsSourceSelectionRequired'] == null ? undefined : json['googleAnalyticsSourceSelectionRequired'],
        'erpAvailable': json['erpAvailable'] == null ? undefined : json['erpAvailable'],
        'datixoEventsAvailable': json['datixoEventsAvailable'] == null ? undefined : json['datixoEventsAvailable'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleCrossSystemDailyRowDataFromJSON)),
    };
}

export function GoogleCrossSystemReportDataToJSON(json: any): GoogleCrossSystemReportData {
    return GoogleCrossSystemReportDataToJSONTyped(json, false);
}

export function GoogleCrossSystemReportDataToJSONTyped(value?: GoogleCrossSystemReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'] == null ? value['since'] : value['since'].toISOString().substring(0,10),
        'until': value['until'] == null ? value['until'] : value['until'].toISOString().substring(0,10),
        'projectCurrency': value['projectCurrency'],
        'paidAvailable': value['paidAvailable'],
        'organicAvailable': value['organicAvailable'],
        'googleAnalyticsAvailable': value['googleAnalyticsAvailable'],
        'organicSourceSelectionRequired': value['organicSourceSelectionRequired'],
        'googleAnalyticsSourceSelectionRequired': value['googleAnalyticsSourceSelectionRequired'],
        'erpAvailable': value['erpAvailable'],
        'datixoEventsAvailable': value['datixoEventsAvailable'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleCrossSystemDailyRowDataToJSON)),
    };
}

